import Vue from 'vue'
import Vuex from 'vuex'
//import router from '../router'
import language from '@/lang'

Vue.use(Vuex)
const defaultLang = localStorage.getItem('lang') || 'cn';
localStorage.getItem('lang')?null:localStorage.setItem('lang',defaultLang);
const store = new Vuex.Store({
    state:{
        routes:[],
        lang:defaultLang,
        langData:language[defaultLang].default
    },
    mutations:{
        changeRouter(state,data){
            state.routes = data;
        },
        changeLang(state,lang){
            state.lang = lang;
            state.langData = language[lang].default;
            //保存配置
            localStorage.setItem('lang',lang);
            location.reload();
        }
    }
})

export default store;